<template>
  <div class="switcher" :class="$isMobile ? 'switcher--mobile' : ''">
    <div @click="setToToday" class="switcher--today" :class="$isMobile ? 'switcher--today--mobile' : ''">Today</div>
    <div class="switcher--dateRange">
      <div v-if="week" @click="switchWeek('back')" class="switcher--arrow">←</div>
      <div v-if="!week" @click="switchDay('back')" class="switcher--arrow">&larr;</div>
      <div class="switcher--current" :class="$isMobile ? 'switcher--current--mobile' : ''">{{ calendarCaption }}</div>
      <div v-if="week" @click="switchWeek('forward')" class="switcher--arrow">&#8594;</div>
      <div v-if="!week" @click="switchDay('forward')" class="switcher--arrow">&#8594;</div>
    </div>
    <div class="switcher--calendarView" v-if="$windowWidth >= 801">
      <div @click="setAsWeek" class="switch week" :class="week ? 'switcher--calendarView--active' : ''">Week</div>
      <div @click="setAsDay" class="switch day" :class="!week ? 'switcher--calendarView--active' : ''">Day</div>
    </div>
    <PreferencesButton />
  </div>
</template>

<script>
// import IconBase from "../../../components/IconBase";
// import IconArrowLeft from "../../../components/SVG/IconArrowLeft";
import PreferencesButton from "../../../components/PreferencesButton";

import { getDate, format, startOfDay, startOfISOWeek } from "date-fns";

import { monthNameShort, dateNum } from "../../../utilities/dateFormatter";

import { ViewController } from "../../../store/calendar/";

const ONE_WEEK = 604800000;
const ONE_DAY = 86400000;

export default {
  name: "Switcher",
  props: ["viewStartMS", "viewEndMS", "userID", "week", "currentSelectedDay"],
  components: {
    PreferencesButton,
    // IconBase,
    // IconArrowLeft,
  },
  computed: {
    // TODO: proper handling of different timezones
    calendarCaption() {
      let caption;
      /* to get the date of right week */
      const FUCK_SUMMER_TIME = 120 * 60 * 1000;
      /* console.log("BEFORE: ", new Date(this.viewStartMS), new Date(this.viewEndMS)); */
      const viewStartMS = this.viewStartMS + FUCK_SUMMER_TIME;
      const viewEndMS = this.viewEndMS - FUCK_SUMMER_TIME;
      /* console.log("CALENDAR CAPTION: ", new Date(viewStartMS), new Date(viewEndMS)); */
      if (this.week) {
        caption = `${monthNameShort(viewStartMS)}, ${dateNum(viewStartMS)} - `;
        if (monthNameShort(viewStartMS) === monthNameShort(viewEndMS)) {
          caption += dateNum(viewEndMS);
        } else {
          caption += `${monthNameShort(viewEndMS)}, ${dateNum(viewEndMS)}`;
        }
      } else {
        let captionDateNum = getDate(this.currentSelectedDay);
        // let captionMonthNumb = format(this.currentSelectedDay, 'LLLL', { locale: ru });
        let captionMonthNum = format(this.currentSelectedDay, "LLLL");
        caption = `${captionMonthNum} ${captionDateNum}`;
      }
      return caption;
    },
  },
  methods: {
    /**
     * If today is within current view boundaries, set to today.
     * Else, set to the first day of the week
     */
    async setAsDay() {
      this.$emit("setAsDay");
    },
    async setAsWeek() {
      if (this.week) return;
      /* console.log("@Switcher setAsWeek"); */
      const start = startOfISOWeek(this.viewStartMS).valueOf();
      const end = start + ONE_WEEK;
      ViewController.switchView(this.userID, start, end);
      this.$store.dispatch("calendar/setWeek", true);
    },

    async switchWeek(prevNext) {
      let start = this.viewEndMS;
      let end = this.viewStartMS;
      if (prevNext === "forward") end = start + ONE_WEEK;
      else start = end - ONE_WEEK;
      await ViewController.switchView(this.userID, start, end);
    },

    async switchDay(prevNext) {
      let start = this.viewEndMS;
      let end = this.viewStartMS;
      if (prevNext === "forward") end = start + ONE_DAY;
      else start = end - ONE_DAY;
      await ViewController.switchView(this.userID, start, end);
    },

    async setToToday() {
      if (this.week) {
        const start = startOfISOWeek(Date.now()).valueOf();
        const end = start + ONE_WEEK;
        await ViewController.switchView(this.userID, start, end);
      } else {
        const start = startOfDay(Date.now()).valueOf();
        const end = start + ONE_DAY;
        await ViewController.switchView(this.userID, start, end);
      }
    },
  },
};
</script>

<style scoped>
/*
  Switcher styles
  */

.switcher {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
  padding-top: 30px;
  position: relative;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  margin-bottom: 5px;
}

.switcher--today {
  border-radius: 360px;
  padding: 8px 25px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  margin-right: 15px;
  z-index: 1;
  color: #222;
  border: 1px solid transparent;
  background-color: white;
  box-shadow: 0 1px 4px 0px #b9b9b94d;
}

.switcher--today:hover {
  background-color: #f5f5f5;
}

.switcher--dateRange {
  display: flex;
  align-items: center;
  margin: auto;
}

.switcher--arrow {
  border-radius: 100%;
  height: 38px;
  width: 38px;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
  color: #222;
  font-weight: bold;
  border: 1px solid transparent;
}

.switcher--arrow:hover {
  background-color: white;
  box-shadow: 0 1px 4px 0px #b9b9b94d;
}

.switcher--current {
  margin: 0 40px;
  font-size: 21px;
  color: #222;
  font-weight: 600;
}

.switcher--calendarView {
  display: flex;
  font-weight: bold;
  margin-right: 15px;
}

.switcher--calendarView > div {
  border-radius: 360px;
  padding: 8px 25px;
  font-size: 16px;
  color: #222;
  font-weight: bold;
  cursor: pointer;
  margin: 0px 3px;
  margin-left: 1px;
  border: 1px solid transparent;
}

.switcher--calendarView > div:hover {
  background-color: white;
  box-shadow: 0 1px 4px 0px #b9b9b94d;
}

.switcher--calendarView--active {
  z-index: 1;
  color: #222;
  background-color: white;
  box-shadow: 0 1px 4px 0px #b9b9b94d;
}
.switcher--mobile {
  padding: 10px;
}
.switcher--today--mobile {
  margin-right: unset;
  padding: 8px 15px;
  font-size: 15px;
  font-weight: 600;
}
.switcher--current--mobile {
  margin: 0 10px;
  font-size: 16px;
}
@media screen and (max-width: 800px) {
  .switcher {
    border-bottom: 1px solid #eaeaea !important;
    margin-bottom: 0px !important;
  }
}
</style>
